"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceForm = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactUseFormState = require("react-use-form-state");
var _reactstrap = require("reactstrap");
var _ = require("./..");
var _SourceFormErrorNotification = _interopRequireDefault(require("./SourceFormErrorNotification"));
var _MediaTypes = require("../../constants/MediaTypes");
var _sourceFileHelper = require("../../utils/sourceFileHelper");
var _SourcePropType = _interopRequireDefault(require("../SourcePropType"));
var _SourceForm = require("./SourceForm.styled");
var _utils = require("../UploadSource/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultErrorState = {
  isValidFile: true,
  isValidFileSize: true
};
var SourceForm = exports.SourceForm = function SourceForm(_ref) {
  var _onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    hasFileInput = _ref.hasFileInput,
    _ref$sources = _ref.sources,
    sources = _ref$sources === void 0 ? [] : _ref$sources,
    source = _ref.source,
    canAssignToPlaceholder = _ref.canAssignToPlaceholder;
  var sourceTitleRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  var _useState5 = (0, _react.useState)(defaultErrorState),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    fileErrors = _useState6[0],
    setFileErrors = _useState6[1];
  var _useFormState = (0, _reactUseFormState.useFormState)({
      title: source ? source.title : '',
      value: undefined,
      sourceId: source ? source._id : undefined,
      ext: ''
    }),
    _useFormState2 = (0, _slicedToArray2["default"])(_useFormState, 2),
    formState = _useFormState2[0],
    text = _useFormState2[1].text;
  var assignToSource = 'Assign to placeholder';
  var createNewMedia = 'Create new content';
  var titleText = 'Content name';
  var submitText = 'Upload';
  var isSubmittingText = 'Uploading...';
  var sourceTitlePlaceholder = '';
  var allowedExtensions = (0, _utils.getAllowedExtensions)();
  var validateFile = function validateFile(uploadedFile, fileExt) {
    setFileErrors(defaultErrorState);
    if (!allowedExtensions.includes(fileExt)) {
      setFileErrors(_objectSpread(_objectSpread({}, fileErrors), {}, {
        isValidFile: false
      }));
    }
    if (uploadedFile.size > _MediaTypes.SUPPORTED_FILE_SIZE) {
      setFileErrors(_objectSpread(_objectSpread({}, fileErrors), {}, {
        isValidFileSize: false
      }));
    }
    setFile(uploadedFile);
  };

  /** It is possible that the allowed extensions have extensions that we don't want to show in the UI. */
  var advertisedExtensions = allowedExtensions.filter(function (ext) {
    return !_MediaTypes.NOT_ADVERTISED_VIDEO_EXTS.includes(ext);
  }).join(', ');
  var onFileChange = function onFileChange(event) {
    var uploadedFile = event.target.files[0];
    var fileExt = (0, _sourceFileHelper.getFileExtension)(uploadedFile.name);
    formState.setField('ext', fileExt);
    if (!formState.values.title || (uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.name) !== file.name) {
      formState.setField('title', uploadedFile.name);
    }
    validateFile(uploadedFile, fileExt);
  };
  var isDisabled = function isDisabled() {
    return !formState.validity.title || isSubmitting || !fileErrors.isValidFile || !fileErrors.isValidFileSize;
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceForm.SourceFormContainer, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Form, {
    "data-test": "sourceCreateForm",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      setIsSubmitting(true);
      _onSubmit(_objectSpread(_objectSpread({}, formState.values), {}, {
        value: file
      }));
    }
  }, hasFileInput && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledFileInputCol, {
    md: 5
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, {
    id: "sourceFileLabel",
    htmlFor: "sourceFile"
  }, "File"), /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledInput, {
    "data-testid": "sourceFileInput",
    type: "file",
    "aria-labelledby": "sourceFileLabel",
    name: "file",
    onChange: onFileChange,
    id: "sourceFile",
    accept: allowedExtensions.join(', ')
  }))), /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledAllowedMediaCol, null, /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledAllowedMediaTypes, null, advertisedExtensions, " (2gb per file size limit)"))), !fileErrors.isValidFile && /*#__PURE__*/_react["default"].createElement(_SourceFormErrorNotification["default"], {
    message: "This file type is not supported!",
    link: "https://learn.shoflo.tv/en/articles/4680854-shoflo-studio-supported-file-types"
  }), !fileErrors.isValidFileSize && /*#__PURE__*/_react["default"].createElement(_SourceFormErrorNotification["default"], {
    message: "The chosen file exceeds the file size limit"
  })), canAssignToPlaceholder ? /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, null, assignToSource), /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledSelect, {
    type: "select",
    "data-testid": "source_dropdown",
    onChange: function onChange(event) {
      formState.setField('sourceId', event.target.value);
    },
    defaultValue: source && source._id
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: ""
  }, createNewMedia), sources.map(function (s) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: s._id,
      value: s._id,
      "data-testid": "source_dropdown_option_".concat(s.title)
    }, s.title);
  }))) : null, /*#__PURE__*/_react["default"].createElement(_reactstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Label, {
    id: "sourceTitleLabel",
    htmlFor: "sourceTitle"
  }, titleText), /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, (0, _extends2["default"])({
    "data-testid": "sourceTitleInput",
    id: "sourceTitle",
    innerRef: sourceTitleRef,
    "aria-labelledby": "sourceTitleLabel",
    placeholder: sourceTitlePlaceholder
  }, text({
    name: 'title',
    validate: function validate(t) {
      return t.length >= 1;
    }
  }), {
    invalid: formState.touched.title && !formState.validity.title,
    required: true
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.FormFeedback, null, "Uh oh! A title is required.")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end"
  }, /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "addButton",
    color: "primary",
    disabled: isDisabled()
  }, isSubmitting ? isSubmittingText : submitText), ' ', /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-test": "cancelButton",
    color: "light",
    variant: "outlined",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    }
  }, "Cancel"))));
};
SourceForm.propTypes = {
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  hasFileInput: _propTypes["default"].bool.isRequired,
  sources: _propTypes["default"].arrayOf(_SourcePropType["default"]),
  source: _SourcePropType["default"],
  canAssignToPlaceholder: _propTypes["default"].bool
};